import { render, staticRenderFns } from "./ReactivateModal.vue?vue&type=template&id=24e9439a&"
import script from "./ReactivateModal.vue?vue&type=script&lang=ts&"
export * from "./ReactivateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports